import { PortalButtonList } from '../button-list';

export class UsersButton extends PortalButtonList {
  name = 'Users'
}